import { useEffect, useState } from 'react';
import { AbsoluteCenter, BigBtnFloatingButton, BigBtnFloatingContainer, BigPlayBtnFloatingButton } from '../../Player/styles';
import { IconFastRewind, IconPause, IconPlayBig, IconPlayForward, IconReplay } from '../../../icons';

const PlayControls = ({ player, isVast = false, isShort = false }: {
  player: HTMLVideoElement;
  isVast?: boolean;
  isShort?: boolean;
}) => {
  const [playState, setPlayState] = useState<'play' | 'pause' | 'ended'>(player && player?.paused ? 'pause' : 'play');
  const [isSeeking, setIsSeeking] = useState(false);

  useEffect(() => {
    player.addEventListener('ended', handleEnded);
    player.addEventListener('playing', handlePlaying);
    player.addEventListener('pause', handlePause);
    player.addEventListener('seeking', handleSeeking);
    player.addEventListener('seeked', handleSeeked);
    return () => {
      player.removeEventListener('ended', handleEnded);
      player.removeEventListener('playing', handlePlaying);
      player.removeEventListener('pause', handlePause);
      player.removeEventListener('seeking', handleSeeking);
      player.removeEventListener('seeked', handleSeeked);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleEnded = () => {
    setPlayState('ended');
  };
  const handlePlaying = () => {
    setIsSeeking(false);
    handlePlay();
  };
  const handlePlay = () => {
    setPlayState('play');
  };
  const handlePause = () => {
    setPlayState('pause');
  };
  const handleSeeking = () => {
    player.paused ? setPlayState('pause') : setPlayState('play');
    setIsSeeking(true);
  };
  const handleSeeked = () => {
    setIsSeeking(false);
  };
  const handlePlayVideo = () => {
    if (playState === 'pause') {
      setPlayState('play');
      player.play();
    } else if (playState === 'play') {
      player.pause();
      setPlayState('pause');
    } else if (playState === 'ended') {
      player.currentTime = 0;
      player.play();
      setPlayState('play');
    }
  };

  const handleSkip = (skipTime) => {
    if (!isSeeking) {
      const currentTime = player.currentTime;
      player.currentTime = currentTime + skipTime;
    }
  };

  // Same as the video.js player: shorts get play/pause only, no 15 second jumps.
  const showSkip = playState !== 'ended' && !isVast && !isShort;

  return (
    <BigBtnFloatingContainer>

      {showSkip && (
        <BigBtnFloatingButton isPlay={false} onClick={() => handleSkip(+15)}>
          <AbsoluteCenter>
            <IconPlayForward />
          </AbsoluteCenter>
        </BigBtnFloatingButton>
      )}

      <BigPlayBtnFloatingButton isPlay={true} onClick={() => handlePlayVideo()}>
        <AbsoluteCenter>{getPlayStateIcon(playState)}</AbsoluteCenter>
      </BigPlayBtnFloatingButton>

      {showSkip && (
        <BigBtnFloatingButton isPlay={false} onClick={() => handleSkip(-15)}>
          <AbsoluteCenter>
            <IconFastRewind />
          </AbsoluteCenter>
        </BigBtnFloatingButton>
      )}

    </BigBtnFloatingContainer>
  );
};

export default PlayControls;

export const getPlayStateIcon = (playState) => {
  if (playState === 'pause') {
    return <IconPlayBig />;
  } else if (playState === 'play') {
    return <IconPause />;
  } else if (playState === 'ended') {
    return <IconReplay />;
  }
  return <IconPlayBig />;
};
